import { render, staticRenderFns } from "./AHSearchMatches.vue?vue&type=template&id=148ff530&"
import script from "./AHSearchMatches.vue?vue&type=script&lang=ts&"
export * from "./AHSearchMatches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports